import { classDefinitionLabel } from '@const/class.constants';
import type { SelectionType } from './search.types';

interface FilterOption {
  label: string;
  value: SelectionType;
  placeholder: string;
}

export const FILTER_OPTIONS: FilterOption[] = [
  { label: 'Search', value: 'search', placeholder: 'Enter search...' },
  { label: 'RegEx', value: 'regex', placeholder: 'Enter regex...' },
  { label: 'Technology', value: 'technology', placeholder: 'Select technology and subsystem...' },
  { label: 'Tag', value: 'tag', placeholder: 'Select tag...' },
  { label: 'Tag Category', value: 'tag_category', placeholder: 'Select category and tag...' },
  { label: 'IP Address', value: 'ip', placeholder: 'e.g. 10.22 or 192.168.1.1' },
  { label: 'MAC Address', value: 'mac', placeholder: 'e.g. 00:11:22:33:44:55' },
  { label: 'WWN', value: 'wwn', placeholder: 'Enter WWN...' },
  { label: 'Volume ID', value: 'volid', placeholder: 'Enter volume ID...' },
  { label: 'Health Status', value: 'health_status', placeholder: 'Select health status...' },
];

export const HEALTH_STATUS_OPTIONS = [
  { label: 'OK', value: 'ok' },
  { label: 'Warning', value: 'warning' },
  { label: 'Error', value: 'error' },
  { label: 'Unknown', value: 'unknown' },
];

export const FILTER_TYPE_LABELS: Record<SelectionType, string> = Object.fromEntries(
  FILTER_OPTIONS.map((opt) => [opt.value, opt.label])
) as Record<SelectionType, string>;

// Search results page classification
export enum ClassKeySearch {
  SERVER = 'server',
}

export const classDefinitionLabelSearch = {
  ...classDefinitionLabel,
  [ClassKeySearch.SERVER]: 'Server',
} as const;
